<template>
  <div class="demo2-container">
    <SkeletonLoader v-if="loading" :loading="loading" />
    <div v-else class="content-wrapper animate__animated animate__fadeIn">
      <!-- 轮播图 -->
      <div class="hero-section" :class="{ 'animate__animated animate__fadeIn': heroSectionVisible }">
        <el-carousel
          height="100vh"
          direction="vertical"
          :autoplay="true"
          :interval="6000"
        >
          <el-carousel-item v-for="(item, index) in carouselData" :key="item.id">
            <div class="hero-slide" :style="{ backgroundImage: `url(${item.resource_path})` }">
              <div class="hero-overlay"></div>
              <div class="hero-content container">
                <template v-if="index === 0">
                  <h2 class="animate__animated animate__fadeInLeft">{{ t('index.slogan').split('-')[0] }}</h2>
                  <h2 class="animate__animated animate__fadeInLeft">{{ t('index.slogan').split('-')[1] }}</h2>
                </template>
                <template v-else>
                  <h2 class="animate__animated animate__fadeInLeft">{{ item.title.split('：')[0] }}</h2>
                  <h3 class="animate__animated animate__fadeInLeft">{{ item.title.split('：')[1] }}</h3>
                </template>
<!--                <p class="animate__animated animate__fadeInLeft animate__delay-1s">{{ t('index.hero_subtitle') }}</p>-->
<!--                <div class="hero-actions animate__animated animate__fadeInUp animate__delay-2s">-->
<!--                  <el-button type="success" size="large" round>{{ t('index.explore_more') }}</el-button>-->
<!--                  <el-button type="info" size="large" round plain>{{ t('index.watch_video') }}</el-button>-->
<!--                </div>-->
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 业务介绍 -->
      <section
        class="business-section"
        :class="{ 'animate__animated animate__fadeIn': businessSectionVisible }"
        v-if="businessData.mining_business || businessData.explosives_business"
      >
        <div class="leaf-bg"></div>
        <div class="container">
          <div class="section-title" :class="{ 'animate__animated animate__fadeInUp': sectionTitleVisible }">
            <span>{{ t('index.our_business_en') }}</span>
            <h2>{{ t('index.ecology_technology') }}</h2>
          </div>

          <div class="business-cards">
            <!-- 矿山业务 -->
            <div
              class="b-card mining"
              :class="{ 'animate__animated animate__fadeInLeft': miningCardVisible }"
              v-if="businessData.mining_business"
            >
              <div class="card-img">
                <img
                  :src="miningBusinessImage || businessImages[0]"
                  :alt="t('index.mining_business')"
                  class="lazy-img"
                  @error="handleImageError('mining')"
                >
              </div>
              <div class="card-content">
                <h3>{{ businessData.mining_business?.page_name || t('index.mining_business') }}</h3>
                <p>{{ miningBusinessText }}</p>
                <router-link
                  :to="`/business/mining`"
                  class="link-arrow"
                  :title="t('index.learn_more')"
                >
                  {{ t('index.learn_more') }} <el-icon><ArrowRight /></el-icon>
                </router-link>
              </div>
            </div>

            <!-- 矿山建设 -->
            <div
              class="b-card mining_c"
              :class="{ 'animate__animated animate__fadeInRight': miningConstructionCardVisible }"
              v-if="businessData.mine_construction"
            >
              <div class="card-img">
                <img
                  :src="miningConstructionImage || businessImages[1]"
                  :alt="t('index.mining_business')"
                  class="lazy-img"
                  @error="handleImageError('mining')"
                >
              </div>
              <div class="card-content">
                <h3>{{ businessData.mine_construction?.page_name || t('index.mine_construction') }}</h3>
                <p>{{ mineConstruction }}</p>
                <router-link
                  :to="`/business/mine-construction`"
                  class="link-arrow"
                  :title="t('index.learn_more')"
                >
                  {{ t('index.learn_more') }} <el-icon><ArrowRight /></el-icon>
                </router-link>
              </div>
            </div>
            <!-- 民爆业务 -->
            <div
              class="b-card explosives"
              :class="{ 'animate__animated animate__fadeInLeft': explosivesCardVisible }"
              v-if="businessData.explosives_business"
            >
              <div class="card-img">
                <img
                  :src="explosivesBusinessImage || businessImages[2]"
                  :alt="t('index.explosives_business')"
                  class="lazy-img"
                  @error="handleImageError('explosives')"
                >
              </div>
              <div class="card-content">
                <h3>{{ businessData.explosives_business?.page_name || t('index.explosives_business') }}</h3>
                <p>{{ explosivesBusinessText }}</p>
                <router-link
                  :to="`/business/explosives`"
                  class="link-arrow"
                  :title="t('index.learn_more')"
                >
                  {{ t('index.learn_more') }} <el-icon><ArrowRight /></el-icon>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 海外业务，ESG，专业 -->
      <section
        class="triple-card-section"
        :class="{ 'animate__animated animate__fadeIn': tripleCardSectionVisible }"
        v-if="businessData.overseas_business || businessData.esg || businessData.technical_strength"
      >
        <div class="container">
<!--          <div class="section-title" :class="{ 'animate__animated animate__fadeInUp': tripleCardTitleVisible }">-->
<!--            <span>{{ t('index.business_advantage_en') }}</span>-->
<!--            <h2>{{ t('index.business_advantage') }}</h2>-->
<!--          </div>-->

          <div class="triple-card-grid">
            <!-- 海外业务 -->
            <div
              class="triple-card overseas"
              :class="{ 'animate__animated animate__fadeInLeft': overseasCardVisible }"
              v-if="businessData.overseas_business"
              :style="{ backgroundImage: `url(${entry[0]})` }"
            >
              <div class="card-overlay"></div>
              <div class="triple-card-content">
                <h3>{{ businessData.overseas_business?.page_name || t('index.overseas_business') }}</h3>
                <p>{{ overseasText }}</p>
                <router-link
                  :to="`/business/overseas`"
                  class="card-link-btn"
                  :title="t('index.learn_more')"
                >
                  <el-icon class="arrow-icon"><ArrowRight /></el-icon>
                </router-link>
              </div>
            </div>

            <!-- ESG 业务 -->
            <div
              class="triple-card esg"
              :class="{ 'animate__animated animate__fadeInUp': esgCardVisible }"
              v-if="businessData.esg"
              :style="{ backgroundImage: `url(${entry[1]})` }"
            >
              <div class="card-overlay"></div>
              <div class="triple-card-content">
                <h3>{{ businessData.esg?.page_name || t('index.esg_business') }}</h3>
                <p>{{ esgText }}</p>
                <router-link
                  :to="`/notice/esg`"
                  class="card-link-btn"
                  :title="t('index.learn_more')"
                >
                  <el-icon class="arrow-icon"><ArrowRight /></el-icon>
                </router-link>
              </div>
            </div>

            <!-- 专业技术 -->
            <div
              class="triple-card technical"
              :class="{ 'animate__animated animate__fadeInRight': technicalCardVisible }"
              v-if="businessData.technical_strength"
              :style="{ backgroundImage: `url(${entry[2]})` }"
            >
              <div class="card-overlay"></div>
              <div class="triple-card-content">
                <h3>{{ businessData.technical_strength?.page_name || t('index.technical_strength') }}</h3>
                <p>{{ techText }}</p>
                <router-link
                  :to="`/business/technical`"
                  class="card-link-btn"
                  :title="t('index.learn_more')"
                >
                  <el-icon class="arrow-icon"><ArrowRight /></el-icon>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 新闻动态 -->
      <section
        class="news-section"
        :class="{ 'animate__animated animate__fadeIn': newsSectionVisible }"
        v-if="homeData.news && homeData.news.length > 0"
      >
        <div class="container">
          <div
            class="section-header"
            :class="{ 'animate__animated animate__fadeInDown': newsHeaderVisible }"
          >
            <h2 style="color: #333333">{{ t('index.latest_news') }}</h2>
            <router-link to="/news" class="view-all">{{ t('index.view_all') }}</router-link>
          </div>

          <div class="news-slider">
            <div
              v-for="(item, index) in homeData.news"
              :key="item.id"
              class="news-card"
              :class="{ 'animate__animated animate__fadeInUp': newsCardsVisible[index] }"
              :style="`animation-delay: ${index * 0.1}s`"
              @click="handleNewsClick(item)"
              :title="item.external_link ? t('index.new_window') : t('index.click_to_view')"
            >
              <div class="news-img">
                <img
                  v-if="item.cover_image"
                  v-lazy="getImageUrl(item.cover_image)"
                  :alt="item.title"
                  class="lazy-img"
                >
                <div class="no-image"></div>
                <span class="news-tag">{{ getCategoryName(item.category) }}</span>
              </div>
              <div class="news-body">
                <span class="date">{{ formatDate(item.publish_time) }}</span>
                <h4>{{ item.title }}</h4>
                <p>{{ truncateText(item.summary || t('index.placeholder_no_summary'), 60) }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 公告与报表 -->
      <section
        class="notice-section"
        :class="{ 'animate__animated animate__fadeIn': noticeSectionVisible }"
        v-if="homeData.notices && homeData.notices.length > 0"
      >
        <div class="container">
          <div
            class="section-header"
            :class="{ 'animate__animated animate__fadeInDown': noticeHeaderVisible }"
          >
            <h2>{{ t('index.announcements_reports') }}</h2>
            <router-link to="/notice" class="view-all">{{ t('index.view_all') }}</router-link>
          </div>

          <div class="notice-grid">
            <div
              v-for="(item, index) in homeData.notices"
              :key="item.id"
              class="notice-card"
              :class="getNoticeCardClass(index)"
              :style="`animation-delay: ${index * 0.1}s`"
              @click="goToNoticeDetail(item.id)"
              :title="t('index.click_to_view')"
            >
              <div class="notice-icon-wrapper">
                <el-icon class="notice-icon">
                  <Document />
                </el-icon>
              </div>
              <div class="notice-content">
                <div class="notice-category">
                  {{ getCategoryName(item.category) }}
                </div>
                <h4 class="notice-title">{{ item.title }}</h4>
<!--                <p class="notice-summary">{{ truncateText(item.summary || t('index.placeholder_no_summary'), 80) }}</p>-->
                <div class="notice-footer">
                  <span class="notice-date">{{ formatDate(item.publish_time) }}</span>
                  <el-icon class="arrow-icon"><ArrowRight /></el-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, inject, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import SkeletonLoader from '@/components/SkeletonLoader.vue';
import {
  ArrowRight,
  Picture,
  Document,
  DataAnalysis,
  Files
} from '@element-plus/icons-vue';
import { getHomeConfigApi } from '@/assets/api/website';

// 使用i18n
const { locale, t } = useI18n();
const router = useRouter();
const route = useRoute();

// 注入布局组件的方法
const layout = inject<{ triggerFooterAnimation: () => void }>('layout', {
  triggerFooterAnimation: () => {}
});

const loading = ref(true);
const homeData = ref<any>({});
const businessData = ref<any>({});

// 动画可见性状态
const heroSectionVisible = ref(false);
const businessSectionVisible = ref(false);
const sectionTitleVisible = ref(false);
const miningCardVisible = ref(false);
const miningConstructionCardVisible = ref(false);
const explosivesCardVisible = ref(false);
const newsSectionVisible = ref(false);
const newsHeaderVisible = ref(false);
const noticeSectionVisible = ref(false);
const noticeHeaderVisible = ref(false);
// 新增动画可见性状态
const tripleCardSectionVisible = ref(false);
const tripleCardTitleVisible = ref(false);
const overseasCardVisible = ref(false);
const esgCardVisible = ref(false);
const technicalCardVisible = ref(false);

// 图片数组（你需要自行 import 图片并赋值）
const entry = ref<string[]>([
  new URL('@/assets/img/e_01.png', import.meta.url).href,
  new URL('@/assets/img/e_02.png', import.meta.url).href,
  new URL('@/assets/img/e_03.jpg', import.meta.url).href,
]);
// 保留轮播图数据（暂时不动）
const carouselData = ref([
  {
    id: 1,
    title: t('index.slogan'),
    // Vite中用new URL解析别名，返回完整的资源路径
    resource_path: new URL('@/assets/img/banner0.jpg', import.meta.url).href
  },
  {
    id: 2,
    title: t('index.mining_business'),
    // Vite中用new URL解析别名，返回完整的资源路径
    resource_path: new URL('@/assets/img/banner5.webp', import.meta.url).href
  },
  {
    id: 3,
    title: t('index.explosives_business'),
    resource_path: new URL('@/assets/img/banner2.jpg', import.meta.url).href
  },
  {
    id: 4,
    title: t('index.our_business'),
    resource_path: new URL('@/assets/img/banner3.jpg', import.meta.url).href
  }
]);
const businessImages = ref<string[]>([
  new URL('@/assets/img/mb.png', import.meta.url).href,
  new URL('@/assets/img/mc.png', import.meta.url).href,
  new URL('@/assets/img/eb.png', import.meta.url).href,
]);

const newsCardsVisible = ref<boolean[]>([]);
const noticeCardsVisible = ref<boolean[]>([]);

// 从content对象中提取富文本内容
const extractRichText = (content: any): string => {
  if (!content) return '';
  if (typeof content === 'string') return content;
  if (content.richtext) return content.richtext;
  return '';
};

// 计算属性：从富文本中提取矿山业务图片
const miningBusinessImage = computed(() => {
  const content = extractRichText(businessData.value.mining_business?.content);
  if (!content) return null;

  try {
    // 从富文本中提取第一张图片
    const imgRegex = /<img[^>]+src=["']([^"']+)["'][^>]*>/i;
    const match = imgRegex.exec(content);
    return match ? match[1] : null;
  } catch (error) {
    console.error('解析矿山业务图片失败:', error);
    return null;
  }
});
// 计算属性：从富文本中提取矿山业务图片
const miningConstructionImage = computed(() => {
  const content = extractRichText(businessData.value.mine_construction?.content);
  if (!content) return null;

  try {
    // 从富文本中提取第一张图片
    const imgRegex = /<img[^>]+src=["']([^"']+)["'][^>]*>/i;
    const match = imgRegex.exec(content);
    return match ? match[1] : null;
  } catch (error) {
    console.error('解析矿山业务图片失败:', error);
    return null;
  }
});
// 计算属性：从富文本中提取矿山业务文字（剔除图片和HTML标签）
const miningBusinessText = computed(() => {
  const content = extractRichText(businessData.value.mining_business?.content);
  if (!content) return t('index.fallback_description_mining');

  try {
    let text = content.replace(/&nbsp;|&ensp;|&emsp;|&thinsp;/gi, ' ')
      .replace(/&zwnj;|&zwj;/gi, '')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;|&apos;/gi, '"');
    // 移除其他HTML标签
    text = text.replace(/<[^>]+>/g, '');
    // 移除多余空白字符
    text = text.replace(/\s+/g, ' ').trim();
    // 截取前100个字符
    return text.length > 100 ? text.substring(0, 100) + '...' : text;
  } catch (error) {
    console.error('解析矿山业务文本失败:', error);
    return t('index.fallback_description_mining');
  }
});
// 计算属性：从富文本中提取矿山业务文字（剔除图片和HTML标签）
const mineConstruction = computed(() => {
  const content = extractRichText(businessData.value.mine_construction?.content);
  if (!content) return t('index.fallback_description_mining');

  try {
    let text = content.replace(/&nbsp;|&ensp;|&emsp;|&thinsp;/gi, ' ')
      .replace(/&zwnj;|&zwj;/gi, '')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;|&apos;/gi, '"');
    // 移除图片标签
    text = text.replace(/<img[^>]*>/gi, '');
    // 移除其他HTML标签
    text = text.replace(/<[^>]+>/g, '');
    // 移除多余空白字符
    text = text.replace(/\s+/g, ' ').trim();
    // 截取前100个字符
    return text.length > 100 ? text.substring(0, 100) + '...' : text;
  } catch (error) {
    console.error('解析矿山业务文本失败:', error);
    return t('index.fallback_description_mining');
  }
});
// 计算属性：从富文本中提取民爆业务图片
const explosivesBusinessImage = computed(() => {
  const content = extractRichText(businessData.value.explosives_business?.content);
  if (!content) return null;

  try {
    // 从富文本中提取第一张图片
    const imgRegex = /<img[^>]+src=["']([^"']+)["'][^>]*>/i;
    const match = imgRegex.exec(content);
    return match ? match[1] : null;
  } catch (error) {
    console.error('解析民爆业务图片失败:', error);
    return null;
  }
});

// 计算属性：从富文本中提取民爆业务文字
const explosivesBusinessText = computed(() => {
  const content = extractRichText(businessData.value.explosives_business?.content);
  if (!content) return t('index.fallback_description_explosives');

  try {
    let text = content.replace(/&nbsp;|&ensp;|&emsp;|&thinsp;/gi, ' ')
      .replace(/&zwnj;|&zwj;/gi, '')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;|&apos;/gi, '"');
    // 移除图片标签
    text = text.replace(/<img[^>]*>/gi, '');
    // 移除其他HTML标签
    text = text.replace(/<[^>]+>/g, '');
    // 移除多余空白字符
    text = text.replace(/\s+/g, ' ').trim();
    // 截取前100个字符
    return text.length > 100 ? text.substring(0, 100) + '...' : text;
  } catch (error) {
    console.error('解析民爆业务文本失败:', error);
    return t('index.fallback_description_explosives');
  }
});
// 计算属性：从富文本中提取海外业务文字（剔除图片和HTML标签）
const overseasText = computed(() => {
  const content = extractRichText(businessData.value.overseas_business?.content);
  if (!content) return t('index.fallback_description_mining');

  try {
    let text = content.replace(/&nbsp;|&ensp;|&emsp;|&thinsp;/gi, ' ')
      .replace(/&zwnj;|&zwj;/gi, '')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;|&apos;/gi, '"');
    // 移除其他HTML标签
    text = text.replace(/<[^>]+>/g, '');
    // 移除多余空白字符
    text = text.replace(/\s+/g, ' ').trim();
    // 截取前100个字符
    return text.length > 100 ? text.substring(0, 100) + '...' : text;
  } catch (error) {
    console.error('解析矿山业务文本失败:', error);
    return t('index.fallback_description_mining');
  }
});
// 计算属性：从富文本中提取海外业务文字（剔除图片和HTML标签）
const esgText = computed(() => {
  const content = extractRichText(businessData.value.esg?.content);
  if (!content) return t('index.fallback_description_mining');

  try {
    let text = content.replace(/&nbsp;|&ensp;|&emsp;|&thinsp;/gi, ' ')
      .replace(/&zwnj;|&zwj;/gi, '')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;|&apos;/gi, '"');
    // 移除其他HTML标签
    text = text.replace(/<[^>]+>/g, '');
    // 移除多余空白字符
    text = text.replace(/\s+/g, ' ').trim();
    // 截取前100个字符
    return text.length > 100 ? text.substring(0, 100) + '...' : text;
  } catch (error) {
    console.error('解析矿山业务文本失败:', error);
    return t('index.fallback_description_mining');
  }
});
// 计算属性：从富文本中提取海外业务文字（剔除图片和HTML标签）
const techText = computed(() => {
  const content = extractRichText(businessData.value.technical_strength?.content);
  if (!content) return t('index.fallback_description_mining');

  try {
    let text = content.replace(/&nbsp;|&ensp;|&emsp;|&thinsp;/gi, ' ')
      .replace(/&zwnj;|&zwj;/gi, '')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;|&apos;/gi, '"');
    // 移除其他HTML标签
    text = text.replace(/<[^>]+>/g, '');
    // 移除多余空白字符
    text = text.replace(/\s+/g, ' ').trim();
    // 截取前100个字符
    return text.length > 100 ? text.substring(0, 100) + '...' : text;
  } catch (error) {
    console.error('解析矿山业务文本失败:', error);
    return t('index.fallback_description_mining');
  }
});
// 工具函数：获取完整的图片URL
const getImageUrl = (imagePath: string) => {
  if (!imagePath) return '';
  // 如果已经是完整URL，直接返回
  if (imagePath.startsWith('http')) return imagePath;
  // 否则添加基础路径
  return `${imagePath}`;
};

// 工具函数：获取分类名称
const getCategoryName = (category: any) => {
  if (!category || !category.name) return t('index.news');

  // 根据分类名称返回对应的国际化文本
  switch (category.name) {
    case '集团新闻':
      return t('index.category_news');
    case '财务报表':
      return t('index.category_financial');
    case '股本申报表':
      return t('index.category_capital');
    case '公告及通函':
      return t('index.category_announcements');
    default:
      return category.name;
  }
};

// 检查是否为公告类别
const isNoticeCategory = (category: any) => {
  if (!category) return true;
  return category.name === '公告及通函';
};

// 检查是否为报表类别
const isReportCategory = (category: any) => {
  if (!category) return false;
  return category.name === '财务报表';
};

// 工具函数：格式化日期
const formatDate = (dateString: string) => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    // 根据不同语言使用不同的日期格式
    const formatKey = 'index.date_format';
    if (t(formatKey) !== formatKey) {
      return t(formatKey, { year, month, day });
    }

    // 如果翻译不存在，使用默认格式
    switch (locale.value) {
      case 'en':
        return `${month}/${day}/${year}`;
      case 'ru':
        return `${day}.${month}.${year}`;
      default:
        return `${year}年${month}月${day}日`;
    }
  } catch (error) {
    console.error('日期格式化错误:', error);
    return dateString;
  }
};

// 工具函数：截断文本
const truncateText = (text: string, maxLength: number) => {
  if (!text) return '';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

const getNoticeCardClass = (index: number) => {
  const baseClass = ['notice-card', 'animate__animated', 'animate__fadeInUp'];
  // 移除notice-card-primary等颜色分类，统一样式
  return baseClass;
};
// 图片加载失败处理
const handleImageError = (type: 'mining' | 'explosives') => {
  console.log(`${type} ${t('index.error_loading')}`);
};

// 新闻点击处理
const handleNewsClick = (item: any) => {
  if (item.external_link) {
    // 如果有external_link，在新标签页打开
    window.open(item.external_link, '_blank');
  } else {
    // 否则跳转到新闻详情页
    router.push(`/news/${item.id}?lang=${locale.value}`);
  }
};

// 跳转到公告详情
const goToNoticeDetail = (id: number) => {
  router.push(`/notice/${id}?lang=${locale.value}`);
};

// 加载首页数据
const loadHomeData = async () => {
  try {
    loading.value = true;

    const response = await getHomeConfigApi({ lang: locale.value });
    if (response) {
      carouselData.value[1].title = response.mining_business.page_name;
      carouselData.value[2].title = response.mine_construction.page_name;
      carouselData.value[3].title = response.explosives_business.page_name;
      homeData.value = response;
      businessData.value = {
        mining_business: response.mining_business,
        explosives_business: response.explosives_business,
        mine_construction: response.mine_construction,
        overseas_business: response.overseas_business, // 新增
        esg: response.esg, // 新增
        technical_strength: response.technical_strength, // 新增
      };

      // 初始化动画状态数组
      if (response.news) {
        newsCardsVisible.value = Array(response.news.length).fill(false);
      }
      if (response.notices) {
        noticeCardsVisible.value = Array(response.notices.length).fill(false);
      }
    }
  } catch (error) {
    console.error(`${t('index.error_loading')}:`, error);
  } finally {
    loading.value = false;
    heroSectionVisible.value = true;

    // 初始触发一次动画检查
    setTimeout(() => {
      triggerScrollAnimations();
    }, 100);
  }
};

// 监听语言变化
watch(locale, () => {
  loadHomeData();
});

const handleScroll = () => {
  triggerScrollAnimations();
};

// 检查元素是否在视窗内
const isElementInViewport = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;

  if (element.classList.contains('footer')) {
    return rect.top <= windowHeight + 100;
  }

  return (
    rect.top <= windowHeight * 0.8 &&
    rect.bottom >= 0
  );
};

// 滚动动画触发函数
const triggerScrollAnimations = () => {
  // Hero Section
  const heroSection = document.querySelector('.hero-section');
  if (heroSection && isElementInViewport(heroSection as HTMLElement)) {
    heroSectionVisible.value = true;
  }

  // Business Section
  const businessSection = document.querySelector('.business-section');
  if (businessSection && isElementInViewport(businessSection as HTMLElement)) {
    businessSectionVisible.value = true;

    const sectionTitle = document.querySelector('.section-title');
    if (sectionTitle && isElementInViewport(sectionTitle as HTMLElement)) {
      sectionTitleVisible.value = true;
    }

    const miningCard = document.querySelector('.b-card.mining');
    if (miningCard && isElementInViewport(miningCard as HTMLElement)) {
      miningCardVisible.value = true;
    }
    const mining_C_Card = document.querySelector('.b-card.mining_c');
    if (mining_C_Card && isElementInViewport(mining_C_Card as HTMLElement)) {
      miningConstructionCardVisible.value = true;
    }
    const explosivesCard = document.querySelector('.b-card.explosives');
    if (explosivesCard && isElementInViewport(explosivesCard as HTMLElement)) {
      explosivesCardVisible.value = true;
    }
  }
// Triple Card Section
  const tripleCardSection = document.querySelector('.triple-card-section');
  if (tripleCardSection && isElementInViewport(tripleCardSection as HTMLElement)) {
    tripleCardSectionVisible.value = true;

    const tripleCardTitle = document.querySelector('.triple-card-section .section-title');
    if (tripleCardTitle && isElementInViewport(tripleCardTitle as HTMLElement)) {
      tripleCardTitleVisible.value = true;
    }

    const overseasCard = document.querySelector('.triple-card.overseas');
    if (overseasCard && isElementInViewport(overseasCard as HTMLElement)) {
      overseasCardVisible.value = true;
    }

    const esgCard = document.querySelector('.triple-card.esg');
    if (esgCard && isElementInViewport(esgCard as HTMLElement)) {
      esgCardVisible.value = true;
    }

    const technicalCard = document.querySelector('.triple-card.technical');
    if (technicalCard && isElementInViewport(technicalCard as HTMLElement)) {
      technicalCardVisible.value = true;
    }
  }
  // News Section
  const newsSection = document.querySelector('.news-section');
  if (newsSection && isElementInViewport(newsSection as HTMLElement)) {
    newsSectionVisible.value = true;

    const newsHeader = document.querySelector('.news-section .section-header');
    if (newsHeader && isElementInViewport(newsHeader as HTMLElement)) {
      newsHeaderVisible.value = true;
    }

    const newsCards = document.querySelectorAll('.news-section .news-card');
    newsCards.forEach((card, index) => {
      if (isElementInViewport(card as HTMLElement)) {
        newsCardsVisible.value[index] = true;
      }
    });
  }

  // Notice Section
  const noticeSection = document.querySelector('.notice-section');
  if (noticeSection && isElementInViewport(noticeSection as HTMLElement)) {
    noticeSectionVisible.value = true;

    const noticeHeader = document.querySelector('.notice-section .section-header');
    if (noticeHeader && isElementInViewport(noticeHeader as HTMLElement)) {
      noticeHeaderVisible.value = true;
    }

    const noticeCards = document.querySelectorAll('.notice-section .notice-card');
    noticeCards.forEach((card, index) => {
      if (isElementInViewport(card as HTMLElement)) {
        noticeCardsVisible.value[index] = true;
      }
    });
  }

  // Footer 动画触发
  const footerSection = document.querySelector('.footer');
  if (footerSection) {
    const rect = footerSection.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isFooterInView = rect.top <= windowHeight + 100;
    const isScrollToBottom = window.scrollY + windowHeight >= document.body.offsetHeight - 100;

    if (isFooterInView || isScrollToBottom) {
      layout.triggerFooterAnimation();
    }
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  loadHomeData();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped lang="scss">
@import "@/assets/css/index";
</style>